import React, { useState } from 'react';
import { Button } from 'reactstrap';

import { space, stopEvent } from '../../base/utils/miscutils';
import { getUrlValue } from '../../base/plumbing/DataStore';
import SearchQuery from '../../base/searchquery';
import { getDataLogData, pivotDataLogToRows } from '../../base/plumbing/DataLog';
import ErrAlert from '../../base/components/ErrAlert';
import { getDataItem } from '../../base/plumbing/Crud';
import KStatus from '../../base/data/KStatus';
import SimpleTable from '../../base/components/SimpleTable';
import Misc from '../../base/components/Misc';

import { ABC } from './GreenTagWidgets';
import { label } from './greenTagPageUtils';
import C from '../../C';


/** TagHealth table campaign column: show name if possible. */
const campaignColumn = {
	Header: 'Campaign',
	Cell: (value, column, item) => item.pvTag.value ? <ABC type={C.TYPES.Campaign} tag={item.pvTag.value} /> : '',
	accessorCSV: item => label('Campaign', item.pvTag.value?.campaign)
};


/** TagHealth SimpleTable columns */
const tagHealthColumns = ['adid', campaignColumn, 'unset', 'count'];


/**
 * Audit Green Ad Tag health - highlight items which may have a setup issue breaking domain data collection.
 * TODO should we move this to a daily server-side process which can send email alerts??
 * @returns 
 */
export function TagHealth() {
	let [go, setGo] = useState();
	if (!go) {
		return <div>
			<h3>Tag Health</h3>
			<Button onClick={e => stopEvent(e) && setGo(true)}>Load Domains Data for all Tags</Button>
		</div>;
	}

	// Get raw data: domain breakdown per tag
	const breakdown = 'adid/domain';
	const agencyId = getUrlValue('agency');
	const q = agencyId ? SearchQuery.setProp(q, 'agency', agencyId).query : '';
	const pvTagData = getDataLogData({q, name: 'tag-health', breakdowns: [breakdown], prob: 0.1, start: '2 weeks ago', dataspace: 'green' });
	console.log('TagHealth pvTagData', pvTagData);

	if (!pvTagData.value) {
		return <div>
			<h3>Tag Health</h3>
			{pvTagData.error ? <ErrAlert error={pvTagData.error} /> : <Misc.Loading />}
		</div>;
	}

	// Pivot breakdown to one row per tag-ID / domain combination,
	// then reduce to count "domain === 'unset'" vs "everything else" per tag-ID.
	// eg { tagIdA: [setCount, unsetCount], tagIdB: [setCount, unsetCount], ... }
	const tagdomainRows = pivotDataLogToRows(pvTagData.value, breakdown);
	console.log('TagHealth pivoted pvTagData', tagdomainRows);
	const set_unset4tag = {};
	tagdomainRows.forEach(row => {
		let set_unset = set_unset4tag[row.adid];
		if (!set_unset) {
			set_unset = [0, 0];
			set_unset4tag[row.adid] = set_unset;
		}
		// increment the "set" or "unset" box
		const index = (row.domain === 'unset') ? 0 : 1;
		set_unset[index] += row.count;
	});

	// Transform set vs unset counts to proportion
	// eg [{ adid: 'tagIdA', unset: 0.743, count: 148270 }, { adid: 'tagIdB', unset: 0.055, count: 839302 }, ...]
	let tagunsetrows = Object.keys(set_unset4tag).map(adid => {
		const [setCount, unsetCount] = set_unset4tag[adid];
		const count = setCount + unsetCount;
		return { adid, unset: (unsetCount / count), count };
	});

	// Filter low counts
	tagunsetrows = tagunsetrows.filter(tur => tur.count > 1000);
	// Filter healthy (leniently set at 15% domains set)
	const allCnt = tagunsetrows.length;
	tagunsetrows = tagunsetrows.filter(tur => tur.unset >= 0.85);
	// Augment rows with a PV fetching their tag object
	tagunsetrows.forEach(tur => {
		tur.pvTag = getDataItem({ type: 'GreenTag', id: tur.adid, status: KStatus.PUBLISHED });
	});

	// Final output: list tags with 85%+ unset domains in a table, show overall count and proportions
	const unhealthyCount = tagunsetrows.length;
	const healthyCount = allCnt - unhealthyCount;
	const unhealthyPercent = (unhealthyCount / allCnt) * 100;
	
	return <div>
		<h3>Tag Health</h3>
		<SimpleTable
			tableName={space('high-unset', label('Agency', agencyId), agencyId)}
			hasFilter rowsPerPage={100} data={tagunsetrows} columns={tagHealthColumns} hasCsv="top"
		/>
		<div>
			Healthy: {healthyCount} Unhealthy: {unhealthyCount} ({unhealthyPercent.toFixed(1)})%
		</div>
	</div>;
}
